<template>
<v-text-field
  :value="value"
  :loading="loading"
  dense
  outlined
  class="ec-font-size16"
  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
  :type="showPassword ? 'text' : 'password'"
  :rules="validate"
  :error-messages="errors"
  :placeholder="placeholder"
  :hide-details="!error"
  background-color="rgba(var(--b3f,250,250,250),1)"
  @click:append="showPassword = !showPassword"
  @input="updateValue"
></v-text-field>
</template>
<script>
import MixinLib from '@/libs/MixinLib'
import ValidationLib from '@/libs/ValidationLib'

export default {
  name: 'ComponentsItemsTextFieldTypePassword',

  mixins: [MixinLib],

  data () {
    return {
      showPassword: false,
      // validate: [],
      placeholder: '',
      error: false,
      errors: ''
    }
  },

  computed: {
    validate: {
      get () {
        return (this.customRules) ? this.rules : ValidationLib.rules(this.name)
      }
    }
  },

  created: function () {
    // this.validate = (this.customRules) ? this.rules : ValidationLib.rules(this.name)
    this.placeholder = ValidationLib.placeholder(this.name)
  },

  methods: {
    updateValue: function (e) {
      this.$emit('update:value', e)
    },

    isError: function () {
      return (this.errors.length > 0)
    },

    confirm: async function () {
      return new Promise((resolve, reject) => {
        try {
          this.errors = ''
          for (var y = 0; y < this.validate.length; y++) {
            const err = this.validate[y](this.value)
            if (err !== true) {
              this.errors = err
              break
            }
          }
          if (this.isError()) {
            this.error = true
            return resolve(false)
          }
          this.error = false
          return resolve(true)
        } catch (e) {
          return reject(e)
        }
      })
    }
  },

  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    customRules: {
      type: Boolean,
      required: false,
      default: () => false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>
